import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { badgeVariants } from '@/components/lemmala-design-system/badge/badge-variants'

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, Omit<VariantProps<typeof badgeVariants>, 'style'> {
  badgeStyle?: VariantProps<typeof badgeVariants>['badgeStyle']
}

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, size, badgeStyle, textCase, ...props }, ref) => {
    return (
      <div
        ref={ref}
        data-testid='badge'
        {...props}
        className={cn(badgeVariants({ variant, size, badgeStyle, textCase }), className)}
      />
    )
  },
)
Badge.displayName = 'Badge'
